import React from 'react';
import { useSelector } from 'react-redux';
import useIsMobile from 'hooks/useIsMobile';
import { INVALID_JOIN_REQUEST } from 'constants/ModalTypes';
import { StyledModal, StyledModalHeader } from '@shoflo/polymer';

import { StyledModalBody } from './InvalidJoinRequestModal.styled';

const InvalidJoinRequestModal = () => {
  const { modal } = useSelector(({ modal }) => ({ modal }));
  const { type: modalType } = modal || {};

  const isOpen = modalType === INVALID_JOIN_REQUEST;
  const isMobile = useIsMobile();

  return (
    <StyledModal isOpen={isOpen} fade={!isMobile}>
      <StyledModalHeader>
        <b>This join URL is Invalid.</b>
      </StyledModalHeader>

      <StyledModalBody>
        This join URL is not valid. The URL may be missing certain characters.
        Make sure the entire URL has been copied and pasted into your browser.
        Refreshing this URL as it currently is will not fix the issue.
      </StyledModalBody>
    </StyledModal>
  );
};

export default InvalidJoinRequestModal;
